// extracted by mini-css-extract-plugin
export default {"advertTab":"e3c7XXM7"};